import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
      backgroundColor: 'var(--surface-inset)',
      '& fieldset': {
        borderColor: 'var(--border-subtle)',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: 'var(--border-default)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--semantic-info)',
        borderWidth: '1px',
      },
    },
    '& .MuiInputLabel-root': {
      color: 'var(--text-secondary)',
      fontSize: 'var(--text-sm)',
      fontFamily: 'var(--font-data)',
      transform: 'translate(12px, 9px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(12px, -9px) scale(0.85)',
        backgroundColor: 'var(--surface-base)',
        paddingLeft: '4px',
        paddingRight: '4px',
      },
      '&.Mui-focused': {
        color: 'var(--semantic-info)',
      },
    },
    '& .MuiInputBase-input': {
      color: 'var(--text-primary)',
      fontSize: 'var(--text-sm)',
      fontFamily: 'var(--font-data)',
      padding: '8px 12px',
    },
  },
};

export default styles;
